import { render, staticRenderFns } from "./QuestionMobile.vue?vue&type=template&id=0e20a37b&scoped=true"
import script from "./QuestionMobile.vue?vue&type=script&lang=js"
export * from "./QuestionMobile.vue?vue&type=script&lang=js"
import style0 from "./QuestionMobile.vue?vue&type=style&index=0&id=0e20a37b&prod&lang=scss&scoped=true"
import style1 from "./QuestionMobile.vue?vue&type=style&index=1&id=0e20a37b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e20a37b",
  null
  
)

export default component.exports